import { CustomSvgProps } from "types/Common";

export const ArrowNewLeft = (props: CustomSvgProps) => {
  return (
    <svg
      width={props.width || "51"}
      height={props.height || "52"}
      fill="none"
      viewBox="0 0 51 52"
      {...props}
      style={{ ...props.style }}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.3074 46.9403C36.8723 46.9403 46.2475 37.565 46.2475 26.0001C46.2475 14.4352 36.8723 5.05994 25.3074 5.05994C13.7424 5.05994 4.36719 14.4352 4.36719 26.0001C4.36719 37.565 13.7424 46.9403 25.3074 46.9403Z"
        stroke="#606A78"
        strokeWidth="1.07692"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9461 33.3919L20.5752 26L27.9461 18.6082"
        stroke="#606A78"
        strokeWidth="1.07692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
